// src/components/ui/card.jsx
import * as React from "react";

export function Card({ className = "", ...props }) {
  return (
    <div
      className={
        "rounded-2xl bg-backgroundSurface text-textPrimary shadow-sm " + className
      }
      style={{ borderWidth: 'var(--card-border-width)', borderColor: 'var(--color-border-default)', borderStyle: 'solid' }}
      {...props}
    />
  );
}

export function CardHeader({ className = "", ...props }) {
  return (
    <div
      className={"flex flex-col space-y-1.5 " + className}
      style={{ padding: 'var(--card-padding)' }}
      {...props}
    />
  );
}

export function CardTitle({ className = "", ...props }) {
  return (
    <h3
      className={"font-semibold leading-none tracking-tight text-textPrimary " + className}
      style={{ fontSize: 'var(--card-title-size)' }}
      {...props}
    />
  );
}

export function CardContent({ className = "", ...props }) {
  return <div className={"p-2 pt-0 " + className} {...props} />;
}
